// Full invitation design model for the tabbed "Kustomisasi Undangan" editor.
export function defaultDesign() {
  return {
    detail: { nama_singkat: "", lokasi_singkat: "" },
    bg: { fit: "cover", position: "center", opacity: 40, blur: 0 },
    cover: {
      enabled: true, eyebrow_top: "The Wedding Of", eyebrow_bottom: "",
      nama_pria: "", nama_wanita: "", subline: "", default_to: "Tamu Undangan",
      button_label: "Buka Undangan", photo: "", photo_url: "",
    },
    pembuka: { enabled: false, text: "", quote: "", quote_source: "", intro: "", bg: "", bg_url: "", photo: "", photo_url: "" },
    pria: { nama_lengkap: "", bio: "", ayah: "", ibu: "", instagram: "", foto: "", foto_url: "" },
    wanita: { nama_lengkap: "", bio: "", ayah: "", ibu: "", instagram: "", foto: "", foto_url: "" },
    countdown: { enabled: true, label_atas: "Menuju Hari Bahagia", calendar_label: "Simpan ke Kalender", photo: "", photo_url: "" },
    kisah: { enabled: true, items: [{ tahun: "", judul: "Pertemuan Pertama", cerita: "" }], photo: "", photo_url: "" },
    acara: { photo: "", photo_url: "" },
    galeri: { enabled: true, quote: "", quote_source: "" },
    gift: {
      enabled: false,
      intro: "Doa restu Anda adalah hadiah terbesar bagi kami. Bagi yang ingin memberikan tanda kasih, dapat melalui:",
      accounts: [], photo: "", photo_url: "",
    },
    rsvp: {
      enabled: true, cta_label: "Konfirmasi Kehadiran", max_tamu: 2,
      field_nama: true, field_kehadiran: true, field_acara: false, field_pesan: true,
      photo: "", photo_url: "",
    },
    ucapan: { enabled: true, default_show: true, photo: "", photo_url: "" },
    penutup: { enabled: true, judul: "Terima kasih", pesan: "", ttd_pria: "", ttd_wanita: "", photo: "", photo_url: "" },
  };
}

// Merge saved design over defaults (one level deep; arrays taken from saved when present).
export function mergeDesign(saved) {
  const def = defaultDesign();
  if (!saved || typeof saved !== "object") return def;
  const out = {};
  for (const k of Object.keys(def)) {
    const dv = def[k];
    const sv = saved[k];
    if (sv && typeof sv === "object" && !Array.isArray(sv)) {
      out[k] = { ...dv, ...sv };
      // preserve nested arrays from saved if present
      for (const kk of Object.keys(dv)) {
        if (Array.isArray(dv[kk]) && Array.isArray(sv[kk])) out[k][kk] = sv[kk];
      }
    } else {
      out[k] = dv;
    }
  }
  // Ensure kisah items have stable _id for drag-reorder
  if (Array.isArray(out.kisah?.items)) {
    out.kisah.items = out.kisah.items.map((it) => (it && it._id ? it : { ...it, _id: makeId() }));
  }
  return out;
}

const makeId = () => (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));

export const emptyStory = () => ({ _id: makeId(), tahun: "", judul: "", cerita: "" });
export const emptyAccount = () => ({ label: "", nomor: "", atas_nama: "" });
export const emptyEvent = (nama = "") => ({ nama, tanggal: "", jam: "", tempat: "", dresscode: "", alamat: "", maps_url: "" });
